// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1jJiU","content":"LoadingAlert_content__30thN"};